<template>
  <Transition name="warehouse-modal-overlay">
    <div
      v-if="visible"
      class="warehouse-modal-overlay warehouse-modal-overlay--glass"
      @click.self="$emit('cancel')"
    >
      <Transition name="warehouse-modal-panel" appear>
        <div
          v-if="visible"
          class="warehouse-modal-card warehouse-modal-card--glass"
          role="dialog"
          aria-modal="true"
          aria-labelledby="warehouse-modal-title"
          @click.stop
        >
          <div class="warehouse-modal-header warehouse-modal-header--glass">
            <h2 id="warehouse-modal-title" class="warehouse-modal-title">Add New Warehouse</h2>
            <button
              type="button"
              class="warehouse-modal-close-btn"
              aria-label="Close"
              title="Close"
              @click="$emit('cancel')"
            >
              <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
          </div>

          <div class="warehouse-modal-body warehouse-modal-body--glass">
            <LabelInputField
              input-id="warehouse-name"
              label="Name"
              v-model="warehouseName"
              placeholder="Warehouse Name"
              required
              flex
              :disabled="saving"
            />
            <div class="warehouse-modal-textarea-wrap">
              <label for="warehouse-description" class="warehouse-modal-textarea-label">Description</label>
              <textarea
                id="warehouse-description"
                class="warehouse-modal-textarea"
                rows="3"
                placeholder="Warehouse Description (Optional)"
                v-model="warehouseDescription"
                :disabled="saving"
              />
            </div>
          </div>

          <div class="warehouse-modal-actions warehouse-modal-actions--glass">
            <SecondaryButton label="Cancel" :disabled="saving" @click="$emit('cancel')" />
            <PrimaryButton label="Save" :loading="saving" @click="ok" />
          </div>
        </div>
      </Transition>
    </div>
  </Transition>

  <ErrorModal
    :show="showErrorModal"
    title="Validation Error"
    :message="errorMessage"
    buttonText="OK"
    @close="closeErrorModal"
  />
</template>

<script>
import '../styles/AddNewWarehouse.css';
import ErrorModal from '@/components/ErrorModal.vue';
import logger from '@/utils/logger';
import ApiService from '@/services/api.service';
import LabelInputField from '@/modules/consultant/components/LabelInputField.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'AddNewWarehouse',
  components: {
    ErrorModal,
    LabelInputField,
    PrimaryButton,
    SecondaryButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      warehouseName: '',
      warehouseDescription: '',
      saving: false,
      showErrorModal: false,
      errorMessage: '',
    };
  },
  methods: {
    async ok() {
      if (!this.warehouseName.trim()) {
        this.errorMessage = 'Warehouse name is required.';
        this.showErrorModal = true;
        return;
      }

      this.saving = true;
      try {
        const response = await ApiService.post('/warehouses', {
          name: this.warehouseName.trim(),
          description: this.warehouseDescription.trim(),
          companyId: this.companyId,
        });

        const warehouse = response.data.data;
        this.$emit('ok', warehouse);
        this.warehouseName = '';
        this.warehouseDescription = '';
      } catch (err) {
        logger.error('Error creating warehouse:', err);

        if (err.response?.data?.errors) {
          this.errorMessage = err.response.data.errors.map((e) => e.message).join(', ');
        } else {
          this.errorMessage = err.response?.data?.message || err.message || 'Failed to create warehouse.';
        }
        this.showErrorModal = true;
      } finally {
        this.saving = false;
      }
    },
    closeErrorModal() {
      this.showErrorModal = false;
      this.errorMessage = '';
    },
  },
};
</script>
